import type { Disclosure } from '../../banking/types/BankAccount';
import { requestBuilder } from '../../http/RequestBuilder';

interface AccountStepIds {
    jointAccountsToOpen: string[];
    memberSoloAccountsToOpen: string[];
    memberJointAccountsToAccept: string[];
    partnerSoloAccountsToOpen: string[];
    partnerJointAccountsToAccept: string[];
}

interface BatchOpenDto {
    disclosures: { disclosures: Disclosure[] };
    submittedCashAccounts: AccountStepIds;
    submittedCardAccounts: AccountStepIds;
    enableAutoPay: boolean;
}

export const useCreateMoneyMapAccounts = requestBuilder.mutation<
    { success: boolean },
    BatchOpenDto,
    { id: string }
>({
    endpoint: ({ id }) => `/api/money-map/${id}/accounts`,
    method: 'POST',
});
